import type { TransferBoardLocation } from "@/pages/manufacturing/transfersWorkbenchTypes";

export function prepackTransferLocationProps(
  locationId: number,
  abbreviation: string | null | undefined,
  mrpSiteCode: string | null | undefined,
): TransferBoardLocation {
  return {
    id: locationId,
    name: null,
    abbreviation: abbreviation ?? null,
    mrp_site_code: mrpSiteCode ?? null,
  };
}
